export interface FPError {
  header: string;
  message: string;
  details?: any;
  event_id?: string[];
}

export interface ErrorDialog {
  show: boolean;
  message?: string;
}

export namespace Failure {
  export abstract class Absract {}
  export class ProcessFailed extends Absract {}
  export class Terminated extends Absract {}
  export class Timeout extends Absract {}
  export class RuntimeFailure extends Absract {}
  export class StorageFailure extends Absract {}
}

export interface ErrorResponse {
  program?: string;
  version?: string;
  release?: string;
  datetime?: string;
  timestamp?: number;
  status?: string;
  code?: number;
  message?: string;
  data?: any;
  error?: string;
}

export const orderFailureKeys = {
  WRONG_PARAMS: 'E_ORDER_WRONG_PARAMS',
  NOT_IMPLEMENTED: 'E_ORDER_NOT_IMPLEMENTED',
  ERROR: 'E_ORDER_ERROR',
  WRONG_ORDER: 'E_ORDER_WRONG_ORDER',
  TWO_FA_PENDING: 'E_ORDER_2FA_PENDING',
  TWO_FA_FAILED: 'E_ORDER_2FA_FAILED',
  WAIT_ORDER: 'E_ORDER_WAIT_ORDER',
  DECTA_ERROR: 'E_DECTA_ERROR',
  DECTA_WRONG_PARAMS: 'E_DECTA_WRONG_PARAMS',
  DECTA_WRONG_CONDITION: 'E_DECTA_WRONG_CONDITION',
};

export const failureKeys = {
  UNKNOWN: 'UNKNOWN',
  NETWORK_ERROR: 'NETWORK_ERROR',
  BAD_REQUEST: 'BAD_REQUEST',
  OFFER_EXPIRED: 'OFFER_EXPIRED',
  SEARCH_RESULT_EXPIRED: 'SEARCH_RESULT_EXPIRED',
  ...orderFailureKeys,
};
